import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { DataMaterialsService } from '@components/materials/data-materials.service';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { DASHBOARD_ROUTES } from '@providers/routes-config';
import * as i0 from "@angular/core";
import * as i1 from "../Providers/global-data/global-data.service";
import * as i2 from "../materials/data-materials.service";
import * as i3 from "@angular/router";
var MaterialsGuard = /** @class */ (function () {
    function MaterialsGuard(globalDataService, dataMaterialsService, router) {
        this.globalDataService = globalDataService;
        this.dataMaterialsService = dataMaterialsService;
        this.router = router;
    }
    MaterialsGuard.prototype.canActivateChild = function (childRoute, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var match, canActivate;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        match = state.url.match(/^\/projects\/(\d+)\/materials/);
                        canActivate = true;
                        if (!(match !== null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.globalDataService.getCurrentProject().subscribe(function (project) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.dataMaterialsService.currentProject = project;
                                            return [4 /*yield*/, this.dataMaterialsService.computeProjectMaterialsData()];
                                        case 1:
                                            _a.sent();
                                            if (!this.dataMaterialsService.hasProjectMaterials()) {
                                                canActivate = false;
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!canActivate) {
                            this.router.navigate([DASHBOARD_ROUTES.GET.dashboard.replace(':pid', match[1])]);
                        }
                        return [2 /*return*/, canActivate];
                }
            });
        });
    };
    MaterialsGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MaterialsGuard_Factory() { return new MaterialsGuard(i0.ɵɵinject(i1.GlobalDataService), i0.ɵɵinject(i2.DataMaterialsService), i0.ɵɵinject(i3.Router)); }, token: MaterialsGuard, providedIn: "root" });
    return MaterialsGuard;
}());
export { MaterialsGuard };
